import Vue from 'vue';
import VueRouter, { RouteConfig } from 'vue-router';
import Home from '@/views/Home.vue';
import { getOpenId, getToken, removeToken } from '@/utils/auth';
import { WEBSITE_TITLE } from '@/config';

Vue.use(VueRouter);

const routes: Array<RouteConfig> = [
  {
    path: '/',
    name: 'Home',
    component: Home,
    meta: {
      title: 'mobox后端云',
    },
  },
  {
    path: '/m_index',
    name: 'Mobile',
    component: () => import('@/views/Mobile.vue'),
    meta: {
      title: 'mobox后端云',
    },
  },
  {
    path: '/template',
    name: 'Template',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import('@/views/Template.vue'),
    meta: {
      title: 'template',
    },
  },
];
const checkDev = () => {
  return window.location.port !== '' ? true : false;
};
const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
});
const MAX_REDIRECT = 3;
// router.beforeEach(async (to, from, next) => {
//   document.title = to.meta.title ? to.meta.title : WEBSITE_TITLE;
//   next();
//   // if (checkDev()) {
//   //   // const id = 48; // test userId
//   //   // const token = await Api.Test.getToken({ id });
//   //   // setToken(token);
//   //   // await getUserInfo();
//   //   return next();
//   // }
//   // const openId = getOpenId();
//   // const token = getToken();
//   // if (!openId || !token) {
//   //   if (to.path === '/auth') {
//   //     next();
//   //   } else {
//   //     let redirectCount =
//   //       Number(localStorage.getItem('REDIRECT_COUNT') || 0) + 1;
//   //     if (redirectCount > MAX_REDIRECT) {
//   //       console.log('redirect count is over max, will clear storage');
//   //       localStorage.clear();
//   //       removeToken();
//   //       redirectCount = 1;
//   //     }
//   //     localStorage.setItem('REDIRECT_COUNT', redirectCount.toString());
//   //     localStorage.setItem('redirectUrl', to.fullPath); //当前页url与参数放入缓存
//   //     next('/auth');
//   //   }
//   // } else {
//   //   localStorage.setItem('REDIRECT_COUNT', '0');
//   //   next();
//   // }
// });
export default router;
